export default {"src":"/_next/static/media/ComplianceAPIDark.a427f450.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};